<hc-modal>
    <hc-modal-body>
        <div class="about-modal-content">
            <div class="about-header">
                <img src="./assets/images/hclogo.svg" class="about-logo" alt="" />
                <div class="about-app">
                    <div class="about-icon">
                        <div class="cdp-name-img cdp-cdp-icon"></div>
                    </div>
                    <div class="about-name">
                        <div class="cdp-app-name">Health Catalyst Ignite®</div>
                        <div class="about-version">
                            <hc-progress-dots *ngIf="loadingVersion" color="light" [isMini]="true"></hc-progress-dots>
                            <div class="version-line">UI Version {{ version }} ({{ environmentName }})</div>
                            <div class="version-line" *ngIf="!loadingVersion && apiVersion">
                                API Version {{ apiVersion }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-footer">
                Copyright 2026 <a href="https://www.healthcatalyst.com/" target="_blank">Health Catalyst</a>. All rights
                reserved
                <br />
                <a href="https://www.healthcatalyst.com/terms-conditions/" target="_blank">Terms and Conditions</a> |
                <a href="https://www.healthcatalyst.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </div>
            <hr class="about-divider" />
            <div class="about-close-container">
                <button hc-button class="about-close" (click)="close()">Close</button>
            </div>
        </div>
    </hc-modal-body>
</hc-modal>
